<img src="assets/images/unPlugged.png" alt="unplugged" />
<h1 class="motif-h4-default-regular">{{ 'logout.title' | translate }}</h1>
@if (isLogoutByTimeout) {
  <p [innerHTML]="'logout.timeout-reason' | translate"></p>
}
<button motifButton color="primary" (click)="login()">
  <motif-icon [iconFunction]="logInIcon" /> {{ 'logout.cta' | translate }}
</button>
